module.exports = __webpack_public_path__ + "static/img/ezwel-renewal-thumb.15adde1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/ezwel-renewal-thumb.jpg
// module id = kveY
// module chunks = 0